import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.dashboard');
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import Chart from 'chart.js/auto';
import { Service } from "src/libs/portal/ggeea/service";

type DashboardHourlyPoint = { label: string; value: number; total: number; faq: number; llm: number };

@Component({
    selector: 'wiz-page-admin-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
  width: 100%;
}

.admin-page {
  position: relative;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.admin-page__content {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  opacity: 1;
  transform: translateY(0);
  transition: opacity 220ms ease, transform 220ms ease, visibility 220ms ease;
}

.admin-page__content.is-hidden {
  visibility: hidden;
  opacity: 0;
  transform: translateY(4px);
}

.admin-page__loading {
  position: absolute;
  inset: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  border-radius: 24px;
  background: rgba(248, 250, 252, 0.86);
  backdrop-filter: blur(10px);
}

.admin-page__loading-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
}

.admin-page__loading-title {
  color: #18181b;
  font-size: 14px;
  font-weight: 700;
}

.admin-page__loading-copy {
  color: #71717a;
  font-size: 12px;
}

.dashboard-kpi-strip {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid #e4e4e7;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 16px 34px -36px rgba(15, 23, 42, 0.55);
}

.dashboard-kpi-item {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
  min-height: 76px;
  padding: 14px 14px;
  border-right: 1px solid #f4f4f5;
}

.dashboard-kpi-item:last-child {
  border-right: 0;
}

.dashboard-kpi-item__icon {
  position: absolute;
  top: 14px;
  right: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  background: #f4f4f5;
  color: #52525b;
  font-size: 12px;
}

.dashboard-kpi-item__body {
  width: 100%;
  min-width: 0;
}

.dashboard-kpi-item__label {
  color: #71717a;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  overflow: hidden;
  padding-right: 32px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-kpi-item__value {
  margin-top: 4px;
  color: #18181b;
  font-size: 22px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-kpi-item--sky .dashboard-kpi-item__icon {
  background: #e0f2fe;
  color: #0284c7;
}

.dashboard-kpi-item--sky .dashboard-kpi-item__value {
  color: #0284c7;
}

.dashboard-kpi-item--violet .dashboard-kpi-item__icon {
  background: #ede9fe;
  color: #7c3aed;
}

.dashboard-kpi-item--violet .dashboard-kpi-item__value {
  color: #7c3aed;
}

.dashboard-kpi-item--emerald .dashboard-kpi-item__icon {
  background: #dcfce7;
  color: #059669;
}

.dashboard-kpi-item--emerald .dashboard-kpi-item__value {
  color: #059669;
}

.dashboard-kpi-item--amber .dashboard-kpi-item__icon {
  background: #fef3c7;
  color: #d97706;
}

.dashboard-kpi-item--amber .dashboard-kpi-item__value {
  color: #d97706;
}

.dashboard-analytics-grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 16px;
}

.dashboard-analytics-card {
  display: flex;
  flex-direction: column;
  min-height: 240px;
  padding: 20px;
  border: 1px solid #f4f4f5;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 10px 24px -28px rgba(15, 23, 42, 0.28);
}

.dashboard-analytics-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.dashboard-analytics-card__title {
  color: #18181b;
  font-size: 15px;
  font-weight: 700;
}

.dashboard-analytics-card__caption {
  color: #a1a1aa;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.dashboard-analytics-card__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  min-height: 120px;
  color: #a1a1aa;
  font-size: 13px;
  text-align: center;
}

.dashboard-analytics-card__empty.is-compact {
  min-height: 96px;
}

.dashboard-analytics-card--hourly {
  min-width: 0;
}

.dashboard-hourly__canvas {
  position: relative;
  height: 240px;
}

.dashboard-analytics-card--faqmix {
  justify-content: flex-start;
}

.dashboard-faqmix {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  flex: 1 1 auto;
  margin-top: 4px;
}

.dashboard-faqmix__canvas-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-faqmix__canvas {
  position: relative;
  width: min(100%, 180px);
  height: 180px;
}

.dashboard-faqmix__legend {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dashboard-faqmix__legend-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid #f4f4f5;
  border-radius: 14px;
  background: #fafafa;
}

.dashboard-faqmix__legend-main {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.dashboard-faqmix__legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  flex: 0 0 10px;
}

.dashboard-faqmix__legend-dot.is-faq {
  background: #8b5cf6;
}

.dashboard-faqmix__legend-dot.is-llm {
  background: #10b981;
}

.dashboard-faqmix__legend-label {
  color: #18181b;
  font-size: 13px;
  font-weight: 600;
}

.dashboard-faqmix__legend-meta {
  text-align: right;
}

.dashboard-faqmix__legend-value {
  color: #09090b;
  font-size: 13px;
  font-weight: 700;
}

.dashboard-faqmix__legend-count {
  color: #a1a1aa;
  font-size: 11px;
}

.dashboard-popular-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 6px;
}

.dashboard-popular-item {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #f4f4f5;
  border-radius: 14px;
  background: #fafafa;
}

.dashboard-popular-item__rank {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #f4f4f5;
  color: #71717a;
  font-size: 11px;
  font-weight: 700;
}

.dashboard-popular-item__rank.is-top {
  background: #10b981;
  color: #ffffff;
}

.dashboard-popular-item__keyword {
  min-width: 0;
  color: #18181b;
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-popular-item__count {
  color: #a1a1aa;
  font-size: 11px;
  white-space: nowrap;
}

.dashboard-recent,
:host ::ng-deep .dashboard-recent {
  box-shadow: 0 18px 40px -38px rgba(15, 23, 42, 0.45);
}

.dashboard-recent__link,
:host ::ng-deep .dashboard-recent__link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid #bbf7d0;
  background: #f0fdf4;
  color: #047857;
  font-size: 12px;
  font-weight: 600;
  transition: background 0.18s ease, transform 0.18s ease;
}

.dashboard-recent__link:hover,
:host ::ng-deep .dashboard-recent__link:hover {
  background: #dcfce7;
  transform: translateY(-1px);
}

.dashboard-recent-grid,
:host ::ng-deep .dashboard-recent-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.dashboard-recent-card,
:host ::ng-deep .dashboard-recent-card {
  width: 100%;
  min-height: 170px;
  padding: 18px;
  border: 1px solid #e4e4e7;
  border-radius: 22px;
  background: linear-gradient(180deg, #ffffff 0%, #fafaf9 100%);
  text-align: left;
  cursor: pointer;
  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.dashboard-recent-card:hover,
:host ::ng-deep .dashboard-recent-card:hover {
  transform: translateY(-2px);
  border-color: #86efac;
  box-shadow: 0 16px 32px -28px rgba(16, 185, 129, 0.6);
}

.dashboard-recent-card__head,
.dashboard-recent-card__footer,
:host ::ng-deep .dashboard-recent-card__head,
:host ::ng-deep .dashboard-recent-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.dashboard-recent-card__time,
:host ::ng-deep .dashboard-recent-card__time {
  color: #52525b;
  font-size: 12px;
}

.dashboard-recent-card__session,
:host ::ng-deep .dashboard-recent-card__session {
  margin-top: 4px;
  color: #a1a1aa;
  font-size: 11px;
}

.dashboard-recent-card__count,
:host ::ng-deep .dashboard-recent-card__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px 10px;
  border-radius: 999px;
  background: #f4f4f5;
  color: #52525b;
  font-size: 11px;
  font-weight: 600;
}

.dashboard-recent-card__question,
:host ::ng-deep .dashboard-recent-card__question {
  margin-top: 16px;
  color: #09090b;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.dashboard-recent-card__answer,
:host ::ng-deep .dashboard-recent-card__answer {
  margin-top: 8px;
  color: #52525b;
  font-size: 13px;
  line-height: 1.7;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.dashboard-recent-card__footer,
:host ::ng-deep .dashboard-recent-card__footer {
  margin-top: 18px;
}

.dashboard-recent-card__feedback,
:host ::ng-deep .dashboard-recent-card__feedback {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dashboard-recent-card__badge,
:host ::ng-deep .dashboard-recent-card__badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.dashboard-recent-card__badge.is-positive,
:host ::ng-deep .dashboard-recent-card__badge.is-positive {
  background: #dcfce7;
  color: #047857;
}

.dashboard-recent-card__badge.is-negative,
:host ::ng-deep .dashboard-recent-card__badge.is-negative {
  background: #fee2e2;
  color: #b91c1c;
}

.dashboard-recent-card__badge.is-neutral,
:host ::ng-deep .dashboard-recent-card__badge.is-neutral {
  background: #f4f4f5;
  color: #71717a;
}

.dashboard-recent-card__cta,
:host ::ng-deep .dashboard-recent-card__cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #059669;
  font-size: 12px;
  font-weight: 600;
}

.dashboard-recent-empty,
:host ::ng-deep .dashboard-recent-empty {
  grid-column: 1/-1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  border: 1px dashed #d4d4d8;
  border-radius: 22px;
  color: #a1a1aa;
  font-size: 13px;
}

@media (max-width: 1279px) {
  .dashboard-kpi-strip {
    grid-auto-flow: column;
    grid-auto-columns: minmax(148px, 1fr);
    grid-template-columns: none;
    overflow-x: auto;
    overscroll-behavior-x: contain;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
  }
  .dashboard-kpi-item {
    min-width: 148px;
  }
}
@media (max-width: 900px) {
  .dashboard-analytics-card {
    min-height: auto;
  }
  .dashboard-hourly__canvas {
    height: 220px;
  }
  .dashboard-recent-grid,
  :host ::ng-deep .dashboard-recent-grid {
    grid-template-columns: 1fr;
  }
  .dashboard-recent-card__head,
  .dashboard-recent-card__footer,
  :host ::ng-deep .dashboard-recent-card__head,
  :host ::ng-deep .dashboard-recent-card__footer {
    flex-direction: column;
    align-items: flex-start;
  }
}
@media (max-width: 640px) {
  .dashboard-kpi-item {
    min-width: 138px;
    min-height: 72px;
    padding: 12px;
  }
  .dashboard-kpi-item__icon {
    top: 12px;
    right: 12px;
    width: 22px;
    height: 22px;
    font-size: 11px;
  }
  .dashboard-kpi-item__value {
    font-size: 20px;
  }
}
@media (min-width: 900px) {
  .dashboard-analytics-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-analytics-card--hourly {
    grid-column: 1/-1;
  }
}
@media (min-width: 1200px) {
  .dashboard-analytics-grid {
    grid-template-columns: minmax(0, 1.35fr) minmax(0, 1.35fr) minmax(0, 1fr) minmax(0, 1fr);
  }
  .dashboard-analytics-card--hourly {
    grid-column: span 2;
  }
  .dashboard-faqmix {
    gap: 18px;
  }
}`],
})
export class PageAdminDashboardComponent implements OnInit, OnDestroy {
    public kpi: any = {
        total_q: 0,
        answered: 0,
        answer_rate: 0,
        avg_ttft_ms: 0,
        total_visit: 0,
        period_visit: 0,
        visit_count: 0,
        unique_ip: 0,
        faq_count: 0,
        llm_count: 0,
        faq_ratio: 0,
        llm_ratio: 0,
    };
    public hourly: DashboardHourlyPoint[] = [];
    public popular: any[] = [];
    public recent: any[] = [];
    public loaded: boolean = false;
    public days: number = 1;
    public error: string = '';
    private hourlyChart: Chart | null = null;
    private faqMixChart: Chart | null = null;
    private hourlyFrame: number | null = null;
    private faqMixFrame: number | null = null;
    private readonly sectionLabels: Record<string, string> = {
        kpi: 'KPI',
        hourly: '시간대별 질문량',
        popular: '인기 키워드',
        recent: '최근 대화',
    };

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init();
        this.service.bindCdr(this.cdr);
        await this.load();
    }

    public ngOnDestroy() {
        this.cancelChartFrames();
        this.destroyHourlyChart();
        this.destroyFaqMixChart();
    }

    public async load() {
        this.loaded = false;
        this.error = '';
        this.cancelChartFrames();
        this.destroyHourlyChart();
        this.destroyFaqMixChart();
        await this.service.render();
        try {
            const summary = await this.loadDashboardSummary();
            this.applyDashboardSummary(summary);
        } catch (e: any) {
            this.error = e?.message || String(e);
        }
        this.loaded = true;
        await this.service.render();
        this.scheduleHourlyChartRender();
        this.scheduleFaqMixChartRender();
    }

    public chartTitle(): string {
        return '시간대별 질문량 (오늘 00:00-24:00)';
    }

    public maxHourly(): number {
        let maxValue = 1;
        for (const item of this.hourly) {
            const value = Number(item.total || item.value || 0);
            if (value > maxValue) maxValue = value;
        }
        return maxValue;
    }

    public async changeDays(d: number) {
        this.days = d;
        await this.load();
    }

    public openChat(c: any) {
        this.service.href(`/admin/chats?session=${c.session_id}`);
    }

    public formatPct(v: number): string {
        return (v || 0).toFixed(1) + '%';
    }

    public todayBadgeLabel(): string {
        const today = new Date();
        const year = String(today.getFullYear());
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `오늘 ${year}.${month}.${day}`;
    }

    public formatMs(v: number): string {
        if (!v) return '-';
        return (Number(v) / 1000).toFixed(1) + '초';
    }

    public formatMetricNumber(v: any): string {
        if (v === null || v === undefined || v === '') return '-';
        return new Intl.NumberFormat('ko-KR').format(Number(v || 0));
    }

    public faqMixTotal(): number {
        return Number(this.kpi?.faq_count || 0) + Number(this.kpi?.llm_count || 0);
    }

    public responseMixRows(): Array<{ label: string; count: number; ratio: number; tone: string }> {
        return [
            {
                label: 'FAQ',
                count: Number(this.kpi?.faq_count || 0),
                ratio: Number(this.kpi?.faq_ratio || 0),
                tone: 'faq',
            },
            {
                label: 'LLM',
                count: Number(this.kpi?.llm_count || 0),
                ratio: Number(this.kpi?.llm_ratio || 0),
                tone: 'llm',
            },
        ];
    }

    public trackKeyword = (_: number, row: any) => row?.keyword || _;

    public trackRecent = (_: number, row: any) => row?.session_id || _;

    public trackMixRow = (_: number, row: any) => row?.tone || row?.label || _;

    private async loadDashboardSummary(): Promise<any> {
        try {
            return await this.service.apiHarness('dashboard', 'summary', {
                days: this.days,
                hours: 24,
                popular_limit: 5,
                recent_limit: 6,
                window: 'today',
            }, { cacheTtlMs: 10000, timeoutMs: 12000 });
        } catch (e) {
            return this.loadLegacyDashboardSummary();
        }
    }

    private async loadLegacyDashboardSummary(): Promise<any> {
        const results = await Promise.allSettled([
            this.service.api('dashboard', 'kpi', { days: this.days }),
            this.service.api('dashboard', 'hourly', { hours: 24 }),
            this.service.api('dashboard', 'popular', { limit: 5, window: 'today' }),
            this.service.api('dashboard', 'recent', { limit: 6 }),
        ]);
        const [kpiRes, hourlyRes, popularRes, recentRes] = results;
        return {
            kpi: kpiRes.status === 'fulfilled' ? kpiRes.value : this.kpi,
            hourly: hourlyRes.status === 'fulfilled' ? hourlyRes.value : [],
            popular: popularRes.status === 'fulfilled' ? popularRes.value : [],
            recent: recentRes.status === 'fulfilled' ? recentRes.value : [],
            errors: [
                kpiRes.status === 'rejected' ? { section: 'KPI' } : null,
                hourlyRes.status === 'rejected' ? { section: '시간대별 질문량' } : null,
                popularRes.status === 'rejected' ? { section: '인기 키워드' } : null,
                recentRes.status === 'rejected' ? { section: '최근 대화' } : null,
            ].filter(Boolean),
        };
    }

    private applyDashboardSummary(summary: any) {
        this.kpi = summary?.kpi || this.kpi;
        this.hourly = this.normalizeTodayHourlySeries(summary?.hourly || []);
        this.popular = this.normalizePopular(summary?.popular || []);
        this.recent = Array.isArray(summary?.recent) ? summary.recent : [];

        const failed = (Array.isArray(summary?.errors) ? summary.errors : [])
            .map((item: any) => this.sectionLabels[item?.section] || item?.section)
            .filter(Boolean);
        if (failed.length) {
            this.error = `${failed.join(', ')} 데이터를 불러오지 못했습니다.`;
        }
    }

    private normalizePopular(rows: any[]): any[] {
        return (Array.isArray(rows) ? rows : []).map((p: any) => ({
            keyword: p.keyword,
            hit_count: p.count ?? p.hit_count ?? 0,
        }));
    }

    private normalizeTodayHourlySeries(rows: any[]): DashboardHourlyPoint[] {
        const byHour = new Map<number, { total: number; faq: number; llm: number }>();
        for (const row of (Array.isArray(rows) ? rows : [])) {
            const total = Number(row?.total_q ?? row?.q_count ?? 0);
            const faq = Number(row?.faq_q ?? row?.faq_count ?? 0);
            const llm = Number(row?.llm_q ?? row?.llm_count ?? Math.max(total - faq, 0));
            const date = this.parseHourDate(row?.hour);
            if (!date) continue;

            byHour.set(date.getHours(), { total, faq, llm });
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const series: DashboardHourlyPoint[] = [];
        for (let hour = 0; hour < 24; hour++) {
            const matched = byHour.get(hour);
            const faq = Number(matched?.faq || 0);
            const llm = Number(matched?.llm || 0);
            const total = Number(matched?.total || (faq + llm));
            series.push({
                label: `${String(hour).padStart(2, '0')}:00`,
                value: total,
                total,
                faq,
                llm,
            });
        }
        return series;
    }

    private parseHourDate(value: any): Date | null {
        if (value instanceof Date) {
            return new Date(value.getTime());
        }
        const raw = String(value || '').trim();
        if (!raw) return null;
        const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
        const parsed = new Date(normalized);
        if (Number.isNaN(parsed.getTime())) {
            return null;
        }
        parsed.setMinutes(0, 0, 0);
        return parsed;
    }

    private scheduleHourlyChartRender() {
        if (!this.hourly.length) {
            this.destroyHourlyChart();
            return;
        }
        this.hourlyFrame = requestAnimationFrame(() => {
            this.hourlyFrame = null;
            this.renderHourlyChart();
        });
    }

    private scheduleFaqMixChartRender() {
        if (!this.faqMixTotal()) {
            this.destroyFaqMixChart();
            return;
        }
        this.faqMixFrame = requestAnimationFrame(() => {
            this.faqMixFrame = null;
            this.renderFaqMixChart();
        });
    }

    private renderHourlyChart() {
        const canvas = this.ensureHourlyChartCanvas();
        if (!canvas) return;

        this.destroyHourlyChart();
        this.hourlyChart = new Chart(canvas, {
            type: 'bar',
            data: {
                labels: this.hourly.map((item) => item.label),
                datasets: [
                    {
                        label: 'FAQ',
                        data: this.hourly.map((item) => item.faq),
                        backgroundColor: '#8b5cf6',
                        hoverBackgroundColor: '#7c3aed',
                        borderRadius: 6,
                        borderSkipped: 'bottom',
                        maxBarThickness: 10,
                        categoryPercentage: 0.72,
                        barPercentage: 0.88,
                    },
                    {
                        label: 'LLM',
                        data: this.hourly.map((item) => item.llm),
                        backgroundColor: '#34d399',
                        hoverBackgroundColor: '#10b981',
                        borderRadius: 6,
                        borderSkipped: 'bottom',
                        maxBarThickness: 10,
                        categoryPercentage: 0.72,
                        barPercentage: 0.88,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        displayColors: false,
                        callbacks: {
                            title: (items) => items[0]?.label || '',
                            label: (context) => `${context.dataset.label || '질문'} ${context.parsed.y || 0}건`,
                        },
                    },
                },
                scales: {
                    x: {
                        grid: { display: false },
                        border: { display: false },
                        ticks: {
                            autoSkip: false,
                            maxRotation: 0,
                            minRotation: 0,
                            color: '#a1a1aa',
                            font: { size: 10 },
                            callback: (_value, index) => index % 2 === 0 ? this.hourly[index]?.label || '' : '',
                        },
                    },
                    y: {
                        beginAtZero: true,
                        ticks: {
                            precision: 0,
                            color: '#a1a1aa',
                            font: { size: 10 },
                        },
                        grid: {
                            color: 'rgba(228, 228, 231, 0.8)',
                        },
                        border: { display: false },
                    },
                },
            },
        });
    }

    private renderFaqMixChart() {
        const canvas = this.ensureFaqMixChartCanvas();
        if (!canvas) return;

        this.destroyFaqMixChart();
        const total = this.faqMixTotal();
        const faqCount = Number(this.kpi?.faq_count || 0);
        const llmCount = Number(this.kpi?.llm_count || 0);

        this.faqMixChart = new Chart(canvas, {
            type: 'doughnut',
            data: {
                labels: ['FAQ', 'LLM'],
                datasets: [{
                    data: [faqCount, llmCount],
                    backgroundColor: ['#8b5cf6', '#10b981'],
                    hoverBackgroundColor: ['#7c3aed', '#059669'],
                    borderWidth: 0,
                    spacing: 0,
                    hoverOffset: 0,
                }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                cutout: '72%',
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        displayColors: false,
                        callbacks: {
                            label: (context) => {
                                const count = Number(context.parsed || 0);
                                const ratio = total ? ((count / total) * 100).toFixed(1) : '0.0';
                                return `${context.label} ${count}건 (${ratio}%)`;
                            },
                        },
                    },
                },
            },
        });
    }

    private ensureHourlyChartCanvas(): HTMLCanvasElement | null {
        const existingCanvas = document.getElementById('admin-dashboard-hourly-chart') as HTMLCanvasElement | null;
        if (existingCanvas) {
            return existingCanvas;
        }

        const host = document.querySelector('.dashboard-hourly__canvas') as HTMLDivElement | null;
        if (host) {
            host.style.position = 'relative';
            host.style.display = 'block';
            host.style.height = host.style.height || '240px';
            const canvas = document.createElement('canvas');
            canvas.id = 'admin-dashboard-hourly-chart';
            canvas.style.width = '100%';
            canvas.style.height = '100%';
            host.replaceChildren(canvas);
            return canvas;
        }

        return null;
    }

    private ensureFaqMixChartCanvas(): HTMLCanvasElement | null {
        const existingCanvas = document.getElementById('admin-dashboard-faqmix-chart') as HTMLCanvasElement | null;
        if (existingCanvas) {
            return existingCanvas;
        }

        const host = document.querySelector('.dashboard-faqmix__canvas') as HTMLDivElement | null;
        if (!host) {
            return null;
        }

        const canvas = document.createElement('canvas');
        canvas.id = 'admin-dashboard-faqmix-chart';
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        host.replaceChildren(canvas);
        return canvas;
    }

    private cancelChartFrames() {
        if (this.hourlyFrame !== null) {
            cancelAnimationFrame(this.hourlyFrame);
            this.hourlyFrame = null;
        }
        if (this.faqMixFrame !== null) {
            cancelAnimationFrame(this.faqMixFrame);
            this.faqMixFrame = null;
        }
    }

    private destroyHourlyChart() {
        if (!this.hourlyChart) return;
        this.hourlyChart.destroy();
        this.hourlyChart = null;
    }

    private destroyFaqMixChart() {
        if (!this.faqMixChart) return;
        this.faqMixChart.destroy();
        this.faqMixChart = null;
    }
}

export default PageAdminDashboardComponent;